#import "../../common/graphql/NotesEntityFields.graphql"

query userApproval($id: UUID!, $orderBy: [ApprovalHistoryItemsOrderBy!]) {
  userApproval(id: $id) {
    id
    __typename
    entityId
    _budgetStatus {
      _isBudgetActive
      _isOverBudget
      _caption
      _totalDisplayColumns
      _isColumn1Required
      _column1Caption
      _column1Amount
      _isColumn2Required
      _column2Caption
      _column2Amount
      _isColumn3Required
      _column3Caption
      _column3Amount
      _isColumn4Required
      _column4Caption
      _column4Amount
      _isColumn5Required
      _column5Caption
      _column5Amount
      _isColumn6Required
      _column6Caption
      _column6Amount
    }
    entityApprovalBranchId
    entityApprovalBranchRowTimestamp
    displayEntityApprovalId
    requestedDate
    requiredDate
    isApproved
    approvedDate
    isRejected
    _documentPackageId
    isApprovalTreeViewerAllowed
    isApproverAddingAllowed
    _isExtendedNotePrivileges
    _isExtendedUploadPrivileges
    additionalApprovalInformation
    userEntityApp {
      linkType
      linkTitle
    }
    rejectedDate
    revokedDate
    requesterName
    approvalPersona
    approvalType {
      approvalType
    }
    statusType {
      approvalState
      statusType
    }
    userEntityApp {
      linkType
      linkTitle
      linkHint
    }
    layoutType
    _isValidating
    description6
    amount2
    verificationLinkType {
      linkRouter
      linkHint
    }
    iconType {
      iconType
      iconState
      isApprovalActionAvailable
    }
    approvalSignaturesByEntityApprovalId(orderBy: SORT_ORDER_ASC) {
      nodes {
        id
        additionalInformation
        digitalSignature
        _isRequester
        _isApprover
        _iconState
        _iconHint
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
    isApprover
    isRequester
    isObserver
    isLevelBypassingAllowed
    isPersonalApproverAddingAllowed
    _isRevocable
    isRevoked
    isPending
    isHistory
    approvalBranchId
    branchStatusType {
      approvalState
      statusType
    }
    branchApprovedDate
    branchRejectedDate
    branchDigitalSignature
    approvalTreeId
    treeStatusType {
      statusType
      approvalState
    }
    _lookupNameId
    _isLookupNameApplied
    lookupName {
      address1
      address2
      lookupName
      lookupCode
      city
      state
      zipCode
      country
      emailAccount
      phone
    }

    treeApprovedDate
    treeRejectedDate
    _nameInfo {
      fullname
      addressLine1
      addressLine2
      cityStatePostal
      country
      emailAddress
      contact
      telephoneNumber
      referenceNumber
    }
    description1
    description2
    description3
    description4
    description5
    digitalSignature
    date1
    amount1
    currency {
      isoCode
    }
    businessUnit {
      name
    }
    department {
      name
    }
    companyCorporatePeriod {
      id
      startDate
      endDate
      _periodYear
    }
    approvalHistoryItemsByDisplayEntityApprovalId(orderBy: $orderBy) {
      nodes {
        id
        id1
        entityItemId
        itemDescription1
        _accountName
        itemDescription2
        itemDescription3
        itemDescription4
        itemDescription5
        itemAmount1
        itemAmount4
        itemAmount5
        itemUnit1
        itemDate1
        _isVerified
        _batchComment
        _accountingStampTransactionReference
        setReference
        referenceCode5
        referenceCode1
        referenceCode2
        referenceCode3
        referenceCode4
        referenceCode6
        referenceCode7
        trip {
          notesByEntityId {
            nodes {
              noteComment
            }
            totalCount
          }
          tripItems {
            nodes {
              tripSection {
                name
                layoutType
              }
              notesByEntityId {
                nodes {
                  noteComment
                }
                totalCount
              }
            }
          }
        }
      }
      aggregates {
        sum {
          itemAmount1
        }
      }
    }
    _isNotesExist
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...NotesEntityFields
      }
    }
    _isTagsExist
    entityTagsByEntityId {
      nodes {
        id
        _tagBadgeName
        _tagBadgeColor
      }
    }
    _isEnvironmentalsExist
    entityEnvironmentalsByEntityId {
      nodes {
        description
        startDate
        endDate
        environmentalMetric {
          id
          environmentalMetric
        }
        entityEnvironmentalItems {
          nodes {
            id
            feet
            gallons
            hours
          }
        }
      }
    }
    _isDocumentsExist
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        id
        entityId
        _documentContents
        _isAccountingDocument
        _isDocumentAmountApplied
        isAppliedAmountRetired
        isAppliedAmountOverage
        documentRetiredAmount
        entityDocumentTypeId
        fileIndexInformation
        _isDocumentTypeUpdatable
        _poAllocationTotal
        comment
        documentTypeId
        documentTypes {
          id
          documentType
          isAccountingDocument
          isSigningRequired
          _isAppliableDocumentType
          _isAutoViewDocument
          _isPoSystemDocument
        }
        documentStatusType {
          statusType
        }
        documentStatusExplanation
        documentOverageAmount
        _isDocumentAmountAvailable
        documentAppliedAmounts {
          id
          appliedTotal
          overageTotal
          retiredTotal
          usedTotal
          remainingTotal
          _isRemainingAmountAvailable
          _isRetiringBalanceAllowed
        }
        currency {
          isoCode
        }
        _documentPoolName
        _documentPoolId
        indexName
        indexAmount
        indexCurrencyId
        indexDescription
        indexReferenceNumber
        indexTransactionDate
        _isReportingDocument
        _sharedByUser
        _fileName
        _fileType
        _fileViewer
        _createdDate
        _isDocumentShare
        fileReference
        iconType
        _fileSize
        rowSecurityId
        entityDocumentSecureRowLevels {
          id
          description
          name
          securityLevel
        }
        _uploadDate
        _rowTimestamp
        _isLoading
        _isDeletable
        _isUpdatable
        _isProtected
        _isSelected
        isShareable
        _isLoadFailed
        documentAppliedAmount
        paymentDocument {
          _isApprovalDocumentsRequired
        }
        invoiceDocument {
          _isApprovalDocumentsRequired
          controlTotalAmount
          currencyId
          currency {
            id
            isoCode
            __typename
          }
        }
        documentFileDistributionsByDocumentFileId(orderBy: _CREATED_DATE_ASC) {
          nodes {
            id
            _createdDate
            _isDeletable
            _isUpdatable
            _rowTimestamp
            accountReference
            projectReference
            setReference
            additionalDescription
            referenceCode1
            referenceCode2
            referenceCode3
            referenceCode4
            referenceCode5
            distributionAmount
            tax1099T4TypeId
            isInvoiceSelectable
            documentAppliedAmount
            _ff1Name
            _ff2Name
            _ff3Name
            _ff4Name
          }
          aggregates {
            sum {
              distributionAmount
            }
          }
          totalCount
        }
        extractionTypeId
      }
    }
    userMessagesByEntityId {
      totalCount
    }
    _isTransactionCancelled
    _isAccountingEntryStampedCompleted
    _accountingStampDate
    _accountingStampUserName
    _accountingStampTransactionReference
  }
}
